<template>
  <section class="admin">
    <div class="left">
      <el-menu default-active="ChanPinManYiDu"
               class="el-menu-vertical-demo"
               @select="handleSelect">
        <el-menu-item index="ChanPinManYiDu">
          <span slot="title">产品满意度</span>
        </el-menu-item>
        <el-menu-item index="DiQuXiaoShou">
          <span slot="title">地区销售数据</span>
        </el-menu-item>
        <el-menu-item index="ShiShiDingDan">
          <span slot="title">实时订单</span>
        </el-menu-item>
        <el-menu-item index="XiaShiJiDingDan">
          <span slot="title">小时级订单量</span>
        </el-menu-item>
        <el-menu-item index="ShiChanHangQing">
          <span slot="title">市场行情</span>
        </el-menu-item>
        <el-menu-item index="SuoYouXiaoShou">
          <span slot="title">所有销售数据</span>
        </el-menu-item>
        <el-menu-item index="YueDuXiaoShou">
          <span slot="title">月度销售数据</span>
        </el-menu-item>
        <el-menu-item index="XiaoFeiZheDongCha">
          <span slot="title">消费者洞察</span>
        </el-menu-item>
        <el-menu-item index="ZhiNengJianBao">
          <span slot="title">智能简报</span>
        </el-menu-item>
        <el-menu-item index="GongJiYouHua">
          <span slot="title">供给优化</span>
        </el-menu-item>
        <el-menu-item index="PinLeiDongCha">
          <span slot="title">品类洞察</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <component :is="activeComponent" :regionData="regionData"></component>
    </div>
  </section>
</template>

<script>
import ChanPinManYiDu from "@/pages/admin/components/chan-pin-man-yi-du.vue";
// 地区销售
import DiQuXiaoShou from "@/pages/admin/components/di-qu-xiao-shou.vue";
// 实时订单
import ShiShiDingDan from "@/pages/admin/components/shi-shi-ding-dan.vue";
// 小时级订单
import XiaShiJiDingDan from "@/pages/admin/components/xia-shi-ji-ding-dan.vue";
// 市场行情
import ShiChanHangQing from "@/pages/admin/components/shi-chan-hang-qing.vue";

// 所有销售数据
import SuoYouXiaoShou from "@/pages/admin/components/suo-you-xiao-shou.vue";
// 月度销售数据
import YueDuXiaoShou from "@/pages/admin/components/yue-du-xiao-shou.vue";
// ���费者洞察
import XiaoFeiZheDongCha from "@/pages/admin/components/xiao-fei-zhe-dong-cha.vue";
// 只能简报
import ZhiNengJianBao from "@/pages/admin/components/zhi-neng-jian-bao.vue";
// 供给优化
import GongJiYouHua from "@/pages/admin/components/gong-ji-you-hua.vue";
// 品类洞察
import PinLeiDongCha from "@/pages/admin/components/pin-lei-dong-cha.vue";
export default {
  name: 'admin',
  components: {
    ChanPinManYiDu,
    DiQuXiaoShou,
    ShiShiDingDan,
    XiaShiJiDingDan,
    ShiChanHangQing,
    SuoYouXiaoShou,
    YueDuXiaoShou,
    XiaoFeiZheDongCha,
    ZhiNengJianBao,
    GongJiYouHua,
    PinLeiDongCha
  },
  props: {},
  data() {
    return {
      activeComponent: 'ChanPinManYiDu',
      regionData: {}
    };
  },
  created() {
    this.getRegions()
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.activeComponent = key
    },
    async getRegions() {
      try {
        let res = await this.$http.get('sysDistrict/regions')
        if (res.data.code === 200) {
          console.log(res.data.data)
          this.regionData = res.data.data
        }
      } catch (err) {
        console.error(err)
      }
    }
  },
};
</script>

<style lang="scss">
.admin {
  padding-top: 12px;
  background-color: #fff;
  display: flex;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  .left{
    width: 120px;
  }
  .right{
    flex: 1;
    overflow: hidden;
    .el-table {
      height: calc(100vh - 42px);
      display: flex;
      flex-direction: column;
      .el-table__body-wrapper{
        flex: 1;
        overflow: auto;
      }
    }
  }
}
</style>
